<script setup lang="ts">

import {CircleCheckIcon, InfoIcon, Loader2Icon, OctagonAlertIcon, TriangleAlertIcon } from 'lucide-vue-next'
import {onMounted, ref} from "vue";
import {Toaster, toast} from "vue-sonner";
import {FrontendMessageType} from "../../enums/FrontendMessageType.ts";
import {tw} from "../../utils/tailwind.ts";

interface Message {
    type: FrontendMessageType,
    message: string,
    description?: string
}

interface Props {
    flash: Message[] | null,
}

const props = defineProps<Props>();


onMounted(() => {
    if (props.flash?.length) {
        for (const [key, message] of Object.entries(props.flash)) {
            if (message.type === FrontendMessageType.warning) {
                toast.warning(message.message)
            } else if (message.type === FrontendMessageType.info) {
                toast.info(message.message)
            } else if (message.type === FrontendMessageType.success) {
                toast.success(message.message, {
                    important: true
                })
            } else if (message.type === FrontendMessageType.error) {
                toast.error(message.message, {
                    important: true
                })
            }
        }
    }
})
</script>

<template>
    <Teleport to="body">
        <Toaster
            position="top-center"
            expand
            :visibleToasts="5"
            :cn="tw"
            :gap="10"
            :toastOptions="{
            unstyled: false,
            classes: {
              default: 'bg-background text-secondary-800',
              error: 'bg-error-50 text-error-900',
              success: 'bg-success-50 text-secondary-800',
              warning: 'bg-amber-50 text-amber-900',
              info: 'bg-background text-secondary-800',
            },
            // class: `bg-white shadow-lg border border-gray-200 dark:bg-gray-900 dark:border-gray-700 dark:text-white rounded-lg pl-6 pr-8 py-3 flex gap-4 items-start transition-all duration-300 ease-in-out items-center text-base
            //     `,
      }"
        >
            <template #loading-icon>
                <Loader2Icon class="animate-spin size-4" />
            </template>
            <template #success-icon>
                <CircleCheckIcon class="text-success-500 size-5" />
            </template>
            <template #error-icon>
                <TriangleAlertIcon class="text-error-500 size-5" />
            </template>
            <template #info-icon>
                <InfoIcon class="text-secondary-800 size-5" />
            </template>
            <template #warning-icon>
                <OctagonAlertIcon class="text-amber-500 size-5" />
            </template>
        </Toaster>
    </Teleport>
</template>

<style scoped>

</style>
